var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26574 1.39587C1.26574 1.04618 0.98261 0.762695 0.633357 0.762695C0.284103 0.762695 0.000976562 1.04618 0.000976562 1.39587V14.0593C0.000976562 14.409 0.284103 14.6925 0.633357 14.6925C0.98261 14.6925 1.26574 14.409 1.26574 14.0593V1.39587Z",
    fill: "#003333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.634922 2.02903C0.284804 2.02903 0.000976562 1.74799 0.000976562 1.39586C0.000976562 1.04617 0.284608 0.762695 0.634922 0.762695L6.95561 0.762695C7.30573 0.762695 7.58956 1.04374 7.58956 1.39586C7.58956 1.74555 7.30593 2.02903 6.95561 2.02903H0.634922Z",
    fill: "#003333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.633358 13.426C0.284103 13.426 0.000976563 13.7095 0.000976563 14.0592C0.000976563 14.4089 0.284103 14.6924 0.633358 14.6924H6.95718C7.30643 14.6924 7.58956 14.4089 7.58956 14.0592C7.58956 13.7095 7.30643 13.426 6.95718 13.426H0.633358Z",
    fill: "#003333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47792 8.36106C3.12983 8.36106 2.84766 8.08002 2.84766 7.72789C2.84766 7.3782 3.13214 7.09473 3.47792 7.09473H11.3869C11.735 7.09473 12.0172 7.37577 12.0172 7.72789C12.0172 8.07758 11.7327 8.36106 11.3869 8.36106H3.47792Z",
    fill: "#003333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7482 8.17526L9.6181 11.3093C9.37114 11.5566 8.97073 11.5566 8.72377 11.3093C8.47681 11.062 8.47681 10.6611 8.72377 10.4139L11.4067 7.72754L8.72377 5.04122C8.47681 4.79396 8.47681 4.39305 8.72377 4.14579C8.97073 3.89852 9.37114 3.89852 9.6181 4.14579L12.7482 7.27982C12.9952 7.52709 12.9952 7.92799 12.7482 8.17526Z",
    fill: "#003333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bbc68190.svg";
export { ForwardRef as ReactComponent };